// ============================================================================
// INVARIANTS — Personal Finance V2 (Blueprint §2.4)
// Validadores puros do domínio. Sem dependência React/Firebase.
// Firestore é a ÚNICA fonte da verdade — validation NÃO bloqueia
// categorias que existem no banco mas não no categories.js local.
// ============================================================================

import { DEFAULT_CATEGORIES } from "./categories.js";
import { STATUS } from "./statusMachine.js";

/** INV-MONEY: valor positivo, 2 casas decimais, < 100k */
export function validateMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0)
    return { ok: false, error: "Valor deve ser positivo." };
  if (n >= 100000)
    return { ok: false, error: "Valor excede R$100.000 (sanity cap)." };
  if (Math.round(n * 100) !== Math.round(n * 100))
    return { ok: false, error: "Centavos inválidos." };
  return { ok: true };
}

/** INV-5: Apenas aviso — Firestore é a fonte da verdade */
export function validateClassification(group, category) {
  const g = DEFAULT_CATEGORIES[group];
  if (!g || !g.subs.includes(category)) {
    console.warn(
      `⚠️ Aviso: '${category}' não está em categories.js para '${group}' — dados no Firestore prevalecem.`,
    );
  }
  return { ok: true };
}

/** INV-3 + INV-4: status PAID exige settlementDate */
export function validatePaymentStatus(status, date, settlementDate) {
  if (status === STATUS.PAID) {
    if (!settlementDate) {
      return {
        ok: false,
        error: "Status PAID exige settlementDate preenchido (INV-3).",
      };
    }
    const today = new Date().toISOString().split("T")[0];
    if (date > today && !settlementDate) {
      return {
        ok: false,
        error:
          "Lançamento futuro não pode ser PAID sem settlementDate (INV-4).",
      };
    }
  }
  return { ok: true };
}

/** INV-1 + INV-2: par deve ter valores e datas iguais */
export function validatePairConsistency(income, expense) {
  const errors = [];
  const incVal = Math.round(Number(income.value) * 100);
  const expVal = Math.round(Number(expense.value) * 100);
  if (incVal !== expVal) {
    errors.push(
      `INV-1: Valores divergem — RECEITA=${income.value} vs DESPESA=${expense.value}`,
    );
  }
  if (income.date !== expense.date) {
    errors.push(
      `INV-2: Datas divergem — RECEITA=${income.date} vs DESPESA=${expense.date}`,
    );
  }
  if (income.status !== expense.status) {
    errors.push(
      `Statuses divergem — RECEITA=${income.status} vs DESPESA=${expense.status}`,
    );
  }
  if (errors.length > 0) return { ok: false, error: errors.join("; ") };
  return { ok: true };
}

/** Validação completa — NÃO valida classificação contra categories.js */
export function validateDraft(draft) {
  const checks = [validateMoney(draft.value)];
  if (draft.status) {
    checks.push(
      validatePaymentStatus(draft.status, draft.date, draft.settlementDate),
    );
  }
  const failed = checks.filter((c) => !c.ok);
  if (failed.length > 0) {
    return { ok: false, error: failed.map((f) => f.error).join(" | ") };
  }
  return { ok: true };
}
